import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';

@Injectable({
  providedIn: 'root',
})
export class MessageToastService {
  // eslint-disable-next-line
  constructor(private messageService: MessageService) {}

  showToastError(title, msg, key) {
    this.messageService.add({
      key,
      severity: 'error',
      summary: title,
      detail: msg,
    });
  }

  showToastSuccess(title, msg, key) {
    this.messageService.add({
      key,
      severity: 'success',
      summary: title,
      detail: msg,
    });
  }

  showToastWarn(title, msg, key) {
    this.messageService.add({
      key,
      severity: 'warn',
      summary: title,
      detail: msg,
    });
  }

  clear(key) {
    this.messageService.clear(key);
  }
}
